<template>
    <aside class="main-sidebar">
      <!-- sidebar: style can be found in sidebar.less -->
      <section class="sidebar">
        <!-- sidebar menu: : style can be found in sidebar.less -->
        <ul class="sidebar-menu" data-widget="tree">
          <li class="header">Menu du Back-Office</li>
          <li class="treeview">
            <a href="#">
              <i class="fa fa-music"></i> <span>Gestion des concerts</span>
              <span class="pull-right-container">
              <i class="fa fa-angle-right pull-right"></i>
            </span>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link :to="{ name: 'dashboard' }"><i class="fa fa-list-ol"></i> Liste des concerts</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'concerts.create' }"><i class="fa fa-plus"></i> Nouveau concert</router-link>
              </li>
            </ul>
          </li>
          <!--<li>-->
            <!--<a href="../mailbox/mailbox.html">-->
              <!--<i class="fa fa-envelope"></i> <span>Mailbox</span>-->
              <!--<span class="pull-right-container">-->
              <!--<small class="label pull-right bg-yellow">12</small>-->
              <!--<small class="label pull-right bg-green">16</small>-->
              <!--<small class="label pull-right bg-red">5</small>-->
            <!--</span>-->
            <!--</a>-->
          <!--</li>-->
        </ul>
      </section>
      <!-- /.sidebar -->
    </aside>
</template>

<script>
  export default {
    name: 'DashboardSidebar'
  }
</script>



// WEBPACK FOOTER //
// Sidebar.vue?1214f58c